import { Link } from "react-router-dom";
import { useContext, useState, useEffect } from "react";
import Logo from "../../assets/img/logo.png";
import styles from "./Navbar.module.css";
import { Context } from "../../context/UserContext";
import ConfirmModal from "../layout/ConfirmModal";
import api from "../../utils/api";

const BASE_IMAGE_URL = process.env.REACT_APP_API || 'https://reprobird.com.br/api';

function Navbar({ isMobileMenuOpen, setIsMobileMenuOpen }) {
  const { authenticated, logout } = useContext(Context); 
  const [showConfirm, setShowConfirm] = useState(false);
  const [isAdminDropdownOpen, setIsAdminDropdownOpen] = useState(false);
  const [aviary, setAviary] = useState(null);

  useEffect(() => {
    async function fetchAviary() {
      if (authenticated) {
        try {
          const token = localStorage.getItem('token');
          if (!token) return;

          const response = await api.get('/aviary/myaviarys', {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` }
          });
          
          const data = response.data.aviary || response.data.aviaries || response.data.aviarys || [];
          if (Array.isArray(data) && data.length > 0) {
            setAviary(data[0]);
          } else if (data && !Array.isArray(data)) {
            setAviary(data);
          }
        } catch (error) {
          console.error("Erro ao buscar imagem do criatório na Navbar:", error);
        }
      } else {
        setAviary(null);
      }
    }

    fetchAviary();
  }, [authenticated]);

  const toggleMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  
  const closeMenu = () => {
    setIsMobileMenuOpen(false);
    setIsAdminDropdownOpen(false);
  };

  function handleLogout() {
    closeMenu();
    setShowConfirm(true);
  }

  function confirmLogout() {
    logout();
    setShowConfirm(false);
  }

  const linkDestinoLogo = authenticated ? "/loged" : "/";

  const getAviaryInitial = () => {
    const name = aviary?.name;
    if (name && typeof name === 'string' && name.trim().length > 0) {
      return name.trim().charAt(0).toUpperCase();
    }
    return "🏛️";
  };

  const aviaryImage = aviary?.image;

  return (
    <>
      <nav className={styles.navbar}>
        <div className={styles.nav_container}>
          
          <div className={styles.nav_left}>
            <button 
              className={styles.menu_toggle} 
              onClick={toggleMenu} 
              aria-label="Toggle Navigation"
            >
              ☰
            </button>

            <div className={styles.navbar_brand}>
              <Link to={linkDestinoLogo} className={styles.logoLink} onClick={closeMenu}>
                <img src={Logo} alt="ReproBird" />
                <h6>ReproBird</h6>
              </Link>
            </div>
          </div>

          <ul className={styles.desktop_menu}>
            {authenticated ? (
              <>
                <li className={styles.nav_item_op}><Link to="/cage">Gaiolas</Link></li>
                <li className={styles.nav_item_op}><Link to="/bird">Aves</Link></li>
                <li className={styles.nav_item_op}><Link to="/report">Relatórios</Link></li>
                <li className={styles.nav_item_op}><Link to="/transaction">Financeiro</Link></li>

                <li className={styles.menu_divider}></li>

                <li 
                  className={styles.dropdown_wrapper}
                  onMouseEnter={() => setIsAdminDropdownOpen(true)}
                  onMouseLeave={() => setIsAdminDropdownOpen(false)}
                >
                  <button className={styles.dropdown_btn}>
                    Administrativo <span className={styles.arrow}>▾</span>
                  </button>

                  {isAdminDropdownOpen && (
                    <ul className={styles.dropdown_menu}>
                      <li><Link to="/plans" onClick={closeMenu}>Nossos Planos</Link></li>
                      <li><Link to="/contact" onClick={closeMenu}>Entre em Contato</Link></li>
                      <li><Link to="/feedback" onClick={closeMenu}>Dúvidas / Sugestões</Link></li>
                      <li><Link to="/about" onClick={closeMenu}>Sobre Nós</Link></li>
                    </ul>
                  )}
                </li>

                <li>
                  <button onClick={handleLogout} className={styles.logout_btn}>
                    Sair
                  </button>
                </li>
              </>
            ) : (
              <>
                <li><Link to="/about">Sobre</Link></li>
                <li><Link to="/plans">Planos</Link></li>
                <li><Link to="/contact">Contato</Link></li>
                <li><Link to="/login" className={styles.login_btn}>Entrar</Link></li>
                <li><Link to="/register" className={styles.register_btn}>Cadastrar</Link></li>
              </>
            )}
          </ul>

          <div className={styles.user_area}>
            <div className={styles.avatar}>
              {authenticated ? (
                <Link 
                  to="/aviary" 
                  onClick={closeMenu} 
                  className={styles.avatar_link}
                  title={aviary?.name || "Meu Criatório"}
                >
                  {aviaryImage ? (
                    <img 
                      src={`${BASE_IMAGE_URL}/api/images/aviary/${aviaryImage}`} 
                      alt={aviary?.name || "Criatório"} 
                      className={styles.avatar_img}
                    />
                  ) : (
                    getAviaryInitial()
                  )}
                </Link>
              ) : (
                <Link to="/login" className={styles.avatar_link}>?</Link>
              )}
            </div>
          </div>
        </div>
      </nav>

      {/* Drawer Mobile */}
      <div className={`${styles.drawer_overlay} ${isMobileMenuOpen ? styles.open : ''}`} onClick={closeMenu} />
      <aside className={`${styles.drawer} ${isMobileMenuOpen ? styles.open : ''}`}>
        <div className={styles.drawer_header}>
          <h3>Menu</h3>
          <button className={styles.close_btn} onClick={closeMenu}>✕</button>
        </div>

        <div className={styles.drawer_body}>
          {authenticated ? (
            <>
              <div className={styles.drawer_section}>
                <span className={styles.section_title}>OPERACIONAL</span>
                <ul>
                  <li><Link to="/cage" onClick={closeMenu}>Gaiolas</Link></li>
                  <li><Link to="/bird" onClick={closeMenu}>Aves</Link></li>
                  <li><Link to="/report" onClick={closeMenu}>Relatórios</Link></li>
                  <li><Link to="/transaction" onClick={closeMenu}>Financeiro</Link></li>
                </ul>
              </div>

              <div className={styles.drawer_section}>
                <span className={styles.section_title}>ADMINISTRATIVO</span>
                <ul>
                  <li><Link to="/plans" onClick={closeMenu}>Nossos Planos</Link></li>
                  <li><Link to="/contact" onClick={closeMenu}>Entre em Contato</Link></li>
                  <li><Link to="/feedback" onClick={closeMenu}>Dúvidas / Sugestões</Link></li>
                  <li><Link to="/about" onClick={closeMenu}>Sobre Nós</Link></li>
                </ul>
              </div>

              <div className={styles.drawer_footer}>
                <button onClick={handleLogout} className={styles.drawer_logout}>
                  Sair da Conta
                </button>
              </div>
            </>
          ) : (
            <div className={styles.drawer_section}>
              <span className={styles.section_title}>ACESSO</span>
              <ul>
                <li><Link to="/login" onClick={closeMenu}>Entrar</Link></li>
                <li><Link to="/register" onClick={closeMenu}>Criar Conta</Link></li>
                <li><Link to="/plans" onClick={closeMenu}>Conhecer Planos</Link></li>
                <li><Link to="/about" onClick={closeMenu}>Sobre o Sistema</Link></li>
              </ul>
            </div>
          )}
        </div>
      </aside>

      {showConfirm && (
        <ConfirmModal
          message="Deseja realmente sair da sua conta?"
          onConfirm={confirmLogout}
          onCancel={() => setShowConfirm(false)}
        />
      )}
    </>
  );
}

export default Navbar;